jQuery(document).ready(function ($) {
  var module_name = "payment_review_header";
  let pros_cons_height = $(".pros-cons").height();
  $(".casino-content").css("padding-bottom", pros_cons_height + 24 + "px");
});
